import { render } from "./KalenderAkademik.vue?vue&type=template&id=c684e26e&scoped=true"
import script from "./KalenderAkademik.vue?vue&type=script&lang=js"
export * from "./KalenderAkademik.vue?vue&type=script&lang=js"

import "./KalenderAkademik.vue?vue&type=style&index=0&id=c684e26e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c684e26e"]])

export default __exports__